import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Image } from 'components/Shared';
import { impactCategoryConfig } from 'constants/impactCategoryConfig';
import { convertHexToRGBA } from 'utils/color';
const Text = styled.div `
  font-size: 12px;
`;
const ButtonContainer = styled.div `
  display: flex;
  align-items: center;
  border-radius: 45px;
  padding: 5px 16px 5px 8px;

  ${({ variant, theme }) => {
    if (variant === 'dark') {
        return `
      background:${convertHexToRGBA(theme.palette.grey['A800'], 0.8)};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      color: #fff;
      `;
    }
    return `
    color: ${theme.palette.grey['A300']};
    background: ${convertHexToRGBA(theme.palette.grey['A800'], 0.1)}};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    `;
}}
`;
const ClaimImageContainer = styled.div `
  display: inline-flex !important;
  flex-direction: row;
  margin-right: 8px;
  margin-left: 12px;

  .claim-logo {
    display: flex;

    img,
    svg {
      border-radius: 50%;
      border: 1px solid #c9c9c9;
      padding: 2px;
      background: #fff;
      width: 26px !important;
      height: 26px !important;
      object-fit: fill;
      max-width: unset !important;
      margin-left: -12px !important;
    }
  }
`;
const ImpactClaimButton = ({ impactClaims, handleClick, variant = 'dark', }) => {
    const { t } = useTranslation();
    return (React.createElement(ButtonContainer, { variant: variant, onClick: handleClick },
        React.createElement(ClaimImageContainer, null, impactClaims.edges
            .filter((_, index) => index < 4)
            .map(({ node: impactClaim }) => {
            var _a;
            const FallbackIcon = (_a = impactCategoryConfig[impactClaim.impactCatalogItem.category.type]) === null || _a === void 0 ? void 0 : _a['icon'];
            const iconUrl = impactClaim.impactCatalogItem.iconUrl;
            if (iconUrl)
                return (React.createElement(Image, { className: "claim-logo", key: impactClaim.id, image: { url: impactClaim.impactCatalogItem.iconUrl } }));
            return (React.createElement("span", { className: "claim-logo", key: impactClaim.id },
                React.createElement(FallbackIcon, null)));
        })),
        React.createElement(Text, null, t('impact-claims.title'))));
};
export default ImpactClaimButton;
